export default __webpack_public_path__ + "static/media/05-4.f8d50c76.jpg";